import { Component, AfterViewChecked, ChangeDetectorRef, inject } from '@angular/core';
import { SalesforceComponent } from './sf-targets-ui/salesforce.component';
import { DivisionSalesforceTargetsFormService } from './division-salesforce-targets-form.service';
import { SaveDivisionSettingsFooterComponent } from '../save-footer.component';
import { SalesforceTargetObjectsComponent } from './sf-targets-ui/salesforce-target-objects.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SaveGuardStore } from '@r1-compass-library/guards/save-guard.store';
import { FormUnsavedChangesWarningDivisionSettings } from '@r1-compass-library/guards/hasUnsavedChanges.guard';
import { UtilFormPreviewComponent } from '@r1-compass-library/utilities';
import { injectQueryParams } from 'ngxtension/inject-query-params';

@Component({
    selector: 'r1-compass-app-salesforce-target-objects-mapper',
    imports: [
        SalesforceComponent,
        SaveDivisionSettingsFooterComponent,
        SalesforceTargetObjectsComponent,
        ReactiveFormsModule,
        UtilFormPreviewComponent,
    ],
    providers: [DivisionSalesforceTargetsFormService],
    template: `
        <form [formGroup]="formService.divisionSalesforceTargetsForm" (ngSubmit)="onSave()">
            <r1-compass-app-salesforce />
            <r1-compass-app-salesforce-target-objects />
            <r1-compass-app-save-division-settings-footer
                [disabled]="formService.divisionSalesforceTargetsForm.invalid" />
        </form>
        @if (tfsDebug() === 'true') {
            <r1-compass-lib-util-form-preview [formElement]="formService.divisionSalesforceTargetsForm" />
        }
    `,
})
export class DivisionSalesforceTargetsComponent implements AfterViewChecked, FormUnsavedChangesWarningDivisionSettings {
    readonly #cdr = inject(ChangeDetectorRef);
    protected readonly formService = inject(DivisionSalesforceTargetsFormService);
    readonly #formSaveWarningStore = inject(SaveGuardStore);

    canDeactivate$ = this.#formSaveWarningStore.deriveCanDeactivate$(this.formService.divisionSalesforceTargetsForm);
    saveGuardHandlerFn = this.#formSaveWarningStore.formUnsavedChangesWarningDivisionSettings;

    // TODO - remove once we get to the root of the new route guard issue
    protected tfsDebug = injectQueryParams('debug', { defaultValue: '0' });

    constructor() {
        this.saveGuardHandlerFn({
            form: this.formService.divisionSalesforceTargetsForm,
            canDeactivate$: this.canDeactivate$,
        });
    }

    ngAfterViewChecked(): void {
        this.#cdr.detectChanges();
    }

    public onSave() {
        return this.formService.submit();
    }
}
